import "./styles/tailwind.reset.sass"
import "./styles/Defaults.scss"
import "./styles/tailwind.sass"

import env from "./env"
import initAIModal from "./components/aimodal/oldui"
import initAddins from "./components/addins/oldui"
import initApplicationHeader from "./components/applicationheader/oldui"
import initAudits from "./components/audits/oldui"
import initBookmarks from "./components/bookmarks/oldui"
import initCardView from "./components/cardview/oldui"
import initConceptsPage from "./components/conceptspage/oldui"
import initConfirmationDialog from "./components/confirmationdialog/oldui"
import initContextMenuActions from "./components/contextmenuactions/oldui"
import initContracts from "./components/contracts/oldui"
import initDeployment from "./components/deployment/oldui"
import initFields from "./components/fields/oldui"
import initFlowPanel from "./components/flowpanel/oldui"
import initFooter from "./components/footer/oldui"
import initFooterButtons from "./components/stickyFooter/oldui"
import initIncidents from "./components/incidents/oldui"
import initIndicators from "./components/indicators/oldui"
import initInlineAttachment from "./components/inlineattachments/oldui"
import initItemBoxContextMenu from "./components/itemboxcontextmenu/oldui"
import initItemDetail from "./components/itemdetail/oldui"
import initLateralNavigation from "./components/lateralnavigation/oldui"
import initLauncherPage from "./components/mobile/oldui"
import initLogin from "./components/auth/loginpage/oldui"
import initLogoutPage from "./components/auth/logoutpage/oldui"
import initNotifications from "./components/notifications/oldui"
import initPrintView from "./components/printView/oldui"
import initRecoverPasswordPage from "./components/auth/recoverpasswordpage/oldui"
import initResourceFooter from "./components/resourcefooter/oldui"
import initResourceHeader from "./components/resourceheader/oldui"
import initScripting from "./components/scripting/oldui"
import initThumbTable from "./components/thumbtableview/oldui"
import initTutorial from "./components/tutorial/oldui"
import initWelcomePage from "./components/welcomepage/oldui"
import initWorkspaceCoverPage from "./components/workspacecoverpage/oldui"
import initWorkspaceListPage from "./components/workspacelistpage/oldui"

import { store } from "./store"
import { IOldUIContext, IPageController, ITenForceWindow } from "./global"

declare let window: ITenForceWindow

let previousSubPanel = "overview"

const mapPanelToElementId: Record<string, string[] | undefined> = {
    commentsAndAttachments: ["CommentsTab_Content", "AttachmentsTab_Content"],
    history: ["HistoryTab_Content"],
}

const getCurrentSubPanel = (): string => {
    const tabs = document.getElementById("tabs") as HTMLElement
    if (!!tabs) {
        const hasSubPanels = tabs.style.display !== "none"
        const selectedSubPanel = document.querySelectorAll(
            "#tabs .tab-scroller li.selected",
        )[0]
        return hasSubPanels && selectedSubPanel
            ? (selectedSubPanel.getAttribute("tab-name") as string)
            : "overview"
    }

    return ""
}

const switchToPanel = (panel: string, updateURL: boolean): void => {
    const tabs = document.getElementById("tabs") as HTMLElement
    const contentcontainer = document.querySelector(
        "[id$='_contentcontainer']",
    ) as HTMLElement
    const contentcontainer2 = document.querySelector(
        "[id$='_contentcontainer2']",
    ) as HTMLElement
    const contentcontainer3 = document.getElementById(
        "contentcontainer3",
    ) as HTMLElement

    if (panel === "overview") {
        tabs.style.display = ""
        contentcontainer.removeAttribute("style")
        contentcontainer2.removeAttribute("style")
        contentcontainer3.setAttribute("style", "display: none;")

        if (updateURL) {
            history.pushState(null, "", `#${previousSubPanel}`)
        }
    } else {
        previousSubPanel = getCurrentSubPanel()
        // NOTE: the not silent mode will not work!
        if (panel === "history") {
            const pageController = window.pageController as IPageController
            pageController.loadHistory(true)
        } else if (panel === "commentsAndAttachments") {
            if (window.comments !== undefined) {
                window.comments.refresh()
            }
            if (window.attachments !== undefined) {
                window.attachments.refresh()
            }
        }
        const panelIds = mapPanelToElementId[panel]
        if (panelIds === undefined) {
            return
        }
        tabs.style.display = "none"
        contentcontainer.setAttribute("style", "display: none;")
        contentcontainer2.setAttribute("style", "display: none;")
        contentcontainer3.removeAttribute("style")
        Array.prototype.slice
            .call(
                contentcontainer3.querySelectorAll(
                    ".tid-content:not(.invisible)",
                ),
            )
            .forEach((element: HTMLElement) => {
                element.classList.add("invisible")
            })
        panelIds.forEach((panelId) => {
            const element = document.getElementById(panelId)
            if (!!element) {
                element.classList.remove("invisible")
            }
        })

        if (updateURL && panel in mapPanelToElementId) {
            history.pushState(null, "", `#${panel}`)
        }
    }
}

const openSignatures = (): void =>
    (window.pageController as IPageController).showSignaturesDialog({
        isBusy: () => false,
        showSpinner: () => {
            /* for the oldui */
        },
        hideSpinner: () => {
            /* for the oldui */
        },
    })

const oldUIContext: IOldUIContext = {
    dateFormat: env.momentDateFormatPattern,
    switchToPanel,
    openSignatures,
    decimalSep:
        window.Sys !== undefined
            ? window.Sys.CultureInfo.CurrentCulture.numberFormat
                  .NumberDecimalSeparator
            : ".",
}

window.newUI = {
    addins: initAddins(store, oldUIContext),
    aIModal: initAIModal(store, oldUIContext),
    applicationHeader: initApplicationHeader(store, oldUIContext),
    audits: initAudits(store, oldUIContext),
    bookmarks: initBookmarks(store, oldUIContext),
    cardView: initCardView(store, oldUIContext),
    conceptsPage: initConceptsPage(store, oldUIContext),
    confirmationDialog: initConfirmationDialog(store, oldUIContext),
    contextMenuActions: initContextMenuActions(),
    contracts: initContracts(store, oldUIContext),
    deployment: initDeployment(store, oldUIContext),
    fields: initFields(store, oldUIContext),
    flowPanel: initFlowPanel(store, oldUIContext),
    footer: initFooter(store, oldUIContext),
    footerButtons: initFooterButtons(store, oldUIContext),
    incidents: initIncidents(store, oldUIContext),
    indicators: initIndicators(store, oldUIContext),
    inlineAttachment: initInlineAttachment(store, oldUIContext),
    itemBoxContextMenu: initItemBoxContextMenu(store, oldUIContext),
    itemDetail: initItemDetail(store, oldUIContext),
    lateralNavigation: initLateralNavigation(),
    launcherPage: initLauncherPage(store, oldUIContext),
    loginPage: initLogin(store, oldUIContext),
    logoutPage: initLogoutPage(store, oldUIContext),
    notifications: initNotifications(store),
    printView: initPrintView(store, oldUIContext),
    recoverPage: initRecoverPasswordPage(store, oldUIContext),
    resourceFooter: initResourceFooter(store, oldUIContext),
    resourceHeader: initResourceHeader(store, oldUIContext),
    scripting: initScripting(store, oldUIContext),
    thumbTableView: initThumbTable(store, oldUIContext),
    tutorial: initTutorial(store, oldUIContext),
    welcomePage: initWelcomePage(store, oldUIContext),
    workspaceCoverPage: initWorkspaceCoverPage(store, oldUIContext),
    workspaceListPage: initWorkspaceListPage(store, oldUIContext),
}
